import Reflux from 'reflux';
import InviteActions from 'actions/Invite';
import SteelCompass from 'services/SteelCompass';

import Message from 'services/Message';

var InviteStore = Reflux.createStore({
  listenables: [InviteActions],
  data: {},
  onReset() {
    var steps = [
        'courses',
        'courseAccess',
        'inviteMode',
        'groups',
        'students',
        'email',
        'summary'
      ],
      initialStep = 0;
    this.data = {
      stepOrder: steps,
      stepIndex: initialStep,
      stepName: steps[initialStep],
      inviteMode: null,
      coursesChosen: 0,
      studentsChosen: 0,
      groupsChosen: 0,
      courseAccessChosen: 0,
      selectedCourses: {},
      selectedStudents: {},
      selectedGroups: {},
      selectedCourseAccess: null,
      disabledSteps: {}
    };
    this.trigger(this.data);
  },
  onNextStep(callback) {
    var currentStep = this.data.stepName;
    for (var i = 0; i < this.data.stepOrder.length; i++) {
      var step = this.data.stepOrder[i];
      if (i > this.data.stepIndex && !this.data.disabledSteps[step]) {
        this.data.stepIndex = i;
        this.data.stepName = step;
        this.trigger(this.data);
        if (callback) {
          callback(currentStep, step);
        }
        break;
      }
    }
  },
  getInitialState() {
    var steps = [
        'courses',
        'courseAccess',
        'inviteMode',
        'groups',
        'students',
        'email',
        'summary'
      ],
      initialStep = 0;
    this.data = {
      list: [],
      stepOrder: steps,
      stepIndex: initialStep,
      stepName: steps[initialStep],
      inviteMode: null,
      coursesChosen: 0,
      studentsChosen: 0,
      groupsChosen: 0,
      courseAccessChosen: 0,
      selectedCourses: {},
      selectedStudents: {},
      selectedGroups: {},
      selectedCourseAccess: null,
      disabledSteps: {}
    };
    return this.data;
  },
  onDisableSteps(steps) {
    steps.forEach(step => {
      this.data.disabledSteps[step] = true;
    });
    this.trigger(this.data);
  },
  onSetCourses(selectedCourses, coursesChosen, dontSkip) {
    this.data.selectedCourses = selectedCourses;
    this.data.coursesChosen = coursesChosen;
    if (!dontSkip && this.data.stepName === 'courses' && coursesChosen > 0) {
      this.data.stepIndex++;
      this.data.stepName = this.data.stepOrder[this.data.stepIndex];
    }
    this.trigger(this.data);
  },
  onSetStudents(selectedStudents, studentsChosen) {
    this.data.selectedStudents = selectedStudents;
    this.data.studentsChosen = studentsChosen;
    this.trigger(this.data);
  },
  onSetCourseAccess(selectedCourseAccess, courseAccessChosen) {
    this.data.selectedCourseAccess = selectedCourseAccess;
    this.data.courseAccessChosen = courseAccessChosen;
    this.trigger(this.data);
  },
  onSetGroups(selectedGroups, groupsChosen) {
    this.data.selectedGroups = selectedGroups;
    this.data.groupsChosen = groupsChosen;
    this.trigger(this.data);
  },
  onSetStudentInviteMode(mode) {
    this.data.inviteMode = mode;
    this.trigger(this.data);
  },
  init() {},
  inviteByCircleIds(circleIds, courseIds, courseAccess, callback) {
    let now = new Date(),
      oneMonth = new Date(now),
      sixMonths = new Date(now),
      oneYear = new Date(now),
      dateLookup = null;

    oneMonth.setDate(oneMonth.getDate() + 31);
    sixMonths.setDate(sixMonths.getDate() + 6 * 31);
    oneYear.setDate(oneYear.getDate() + 365);

    dateLookup = {
      oneMonth: oneMonth.toISOString(),
      sixMonths: sixMonths.toISOString(),
      oneYear: oneYear.toISOString(),
      unlimited: '0000-00-00'
    };
    return SteelCompass.call(
      'invite',
      'byCircleIds',
      {
        circleIds: circleIds,
        courseIds: courseIds,
        expires: dateLookup.sixMonths
      },
      () => {
        if (callback) {
          callback();
        }
      }
    );
  },
  inviteByUserIds(userIds, courseIds, courseAccess, callback) {
    let now = new Date(),
      oneMonth = new Date(now),
      sixMonths = new Date(now),
      threeMonths = new Date(now),
      oneYear = new Date(now),
      dateLookup = null;

    oneMonth.setDate(oneMonth.getDate() + 31);
    threeMonths.setDate(threeMonths.getDate() + 3 * 31);
    sixMonths.setDate(sixMonths.getDate() + 6 * 31);
    oneYear.setDate(oneYear.getDate() + 365);

    dateLookup = {
      oneMonth: oneMonth.toISOString(),
      threeMonths: threeMonths.toISOString(),
      sixMonths: sixMonths.toISOString(),
      oneYear: oneYear.toISOString(),
      unlimited: '0000-00-00'
    };
    // if (Math.min(userIds.length, courseIds.length) === 0) {
    //   Message.error('Please')
    //   return;
    // }
    return SteelCompass.call(
      'invite',
      'byUserIds',
      {
        userIds: userIds,
        courseIds: courseIds,
        expires: dateLookup[courseAccess]
      },
      () => {
        if (callback) {
          callback();
        }
      }
    );
  },
  inviteByEmails(emails, courseIds, courseAccess, callback) {
    let now = new Date(),
      oneMonth = new Date(now),
      threeMonths = new Date(now),
      sixMonths = new Date(now),
      oneYear = new Date(now),
      dateLookup = null;

    oneMonth.setDate(oneMonth.getDate() + 31);
    threeMonths.setDate(threeMonths.getDate() + 3 * 31);
    sixMonths.setDate(sixMonths.getDate() + 6 * 31);
    oneYear.setDate(oneYear.getDate() + 365);

    dateLookup = {
      oneMonth: oneMonth.toISOString(),
      threeMonths: threeMonths.toISOString(),
      sixMonths: sixMonths.toISOString(),
      oneYear: oneYear.toISOString(),
      unlimited: '0000-00-00'
    };
    return SteelCompass.call(
      'invite',
      'byEmails',
      {
        emails: emails,
        courseIds: courseIds,
        expires: dateLookup[courseAccess]
      },
      () => {
        if (callback) {
          callback();
        }
      }
    );
  },
  inviteToCircle(emails, circleId, callback) {
    return SteelCompass.request('invite', 'byEmails', {
      emails,
      circleId
    }).then(() => {
      callback && callback();
    });
  }
});

export default InviteStore;



// WEBPACK FOOTER //
// ./src/js/stores/Invite.js